module.exports = __webpack_public_path__ + "img/plus-icon.cd845df7.svg";